import { useMemo } from 'react'

import { F0Heading } from '@factorialco/f0-react'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'

import type { PurchaseOrderDetailFieldsFragment } from 'generated/resources/graphql'

import { sectionLabel } from 'modules/procurement/components/poTemplates/FieldEditor/translations'

import type {
  FieldWithValue,
  HeaderSectionType,
} from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetail/utils'
import {
  displayValue,
  resolveFieldLabel,
} from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetail/utils'

interface Props {
  section: HeaderSectionType
  fields: FieldWithValue[]
  purchaseOrder: PurchaseOrderDetailFieldsFragment
}

function HeaderSection({ section, fields, purchaseOrder }: Props) {
  const details = useMemo(
    () =>
      fields.map((field) => ({
        title: resolveFieldLabel(field.definition),
        content: {
          type: 'item' as const,
          text: displayValue(field, purchaseOrder) || '-',
        },
      })),
    [fields, purchaseOrder]
  )

  if (fields.length === 0) return null

  return (
    <>
      <F0Heading content={sectionLabel(section)} as="h3" />
      <DetailsItemsList details={details} tableView />
    </>
  )
}

export default HeaderSection
